document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.getElementById("variant-specs");
  if (!wrap) return;

  const codeEl = document.getElementById("specs_code");
  const sizeEl = document.getElementById("specs_size");
  const absorptionEl = document.getElementById("specs_absorption");
  const quantityEl = document.getElementById("specs_quantity");

  const specsData = window.variantSpecsData || {};
  const initialId = window.initialVariantId || null;

  const normalize = (val) => (val == null ? "" : String(val).trim());

  function updateSpecs(variantId) {
    if (!variantId) { wrap.style.display = "none"; return; }
    const s = specsData[String(variantId)];
    if (!s) { wrap.style.display = "none"; return; }

    const code = normalize(s.code);
    const size = normalize(s.size);
    const absorption = normalize(s.absorption);
    const quantity = normalize(s.quantity);

    const allEmpty = !size && !absorption && !quantity;
    if (allEmpty) { wrap.style.display = "none"; return; }

    if (code) {
      let shortCode = code;
      const index = code.indexOf("(");
      if (index !== -1) shortCode = code.substring(0, index).trim();
      codeEl.textContent = shortCode;
      codeEl.title = code;
    } else {
      codeEl.textContent = "—";
    }

    sizeEl.textContent = size || "—";
    absorptionEl.textContent = absorption || "—";
    quantityEl.textContent = quantity || "—";

    wrap.style.display = "";
  }

  function getCurrentVariantId() {
    const checked = document.querySelector('input[name="id"]:checked');
    if (checked?.value) return checked.value;

    const sel = document.querySelector('select[name="id"]');
    if (sel?.value) return sel.value;

    const hidden = document.querySelector('input[name="id"][type="hidden"]');
    if (hidden?.value) return hidden.value;

    return null;
  }

  function refresh() {
    updateSpecs(getCurrentVariantId() || initialId);
  }

  document.addEventListener("change", (e) => {
    if (e.target.matches('input[name="id"], select[name="id"]')) refresh();
  });

  document.addEventListener("variant:change", (e) => {
    updateSpecs(e?.detail?.variant?.id || getCurrentVariantId() || initialId);
  });

  document.addEventListener("variant:changed", (e) => {
    updateSpecs(e?.detail?.variant?.id || getCurrentVariantId() || initialId);
  });

  document.addEventListener("shopify:section:load", refresh);

  refresh();
});